<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs/>
          <div class="table-agile-info">
            <div class="common-new-title mode2">
              <span>咨询签约统计</span>
              <!-- <span>
                <el-tooltip
                  placement="right"
                  effect="light">
                  <div slot="content">
                    说明说明说明说明说明<br />
                    说明说明说明说明说明<br />
                  </div>
                  <i class="el-icon-question blue"/>
                </el-tooltip>
              </span> -->
            </div>
            <!-- 查询条件 -->
            <div class="searchList">
              <div class="box-content box-content-double">
                <label class="form-tit">渠道来源</label>
                <jm-channel
                  v-model="searchData.channel"
                  clearable
                  filterable/>
              </div>
              <div class="box-content">
                <label class="form-tit">查询时间</label>
                <el-date-picker
                  clearable
                  class="jm-input280"
                  v-model="searchData.timeline"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd">
                </el-date-picker>
              </div>
              <div class="box-content" v-if="false">
                <label class="form-tit">咨询组</label>
                <el-select
                  :disabled="ds.admin_dept_id>0"
                  v-model="searchData.dept_id"
                  title="选择小组"
                  class="jm-input280"
                  @change="changeGroupTeacher"
                  filterable
                  clearable>
                  <el-option
                    v-for="item in ds.dept_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">咨询老师</label>
                <el-select
                  v-model="searchData.teacher_id"
                  title="请选择"
                  class="jm-input280"
                  multiple
                  filterable
                  clearable>
                  <el-option
                    v-for="option in optionTeacherList"
                    :key="option.userid"
                    :label="option.truename"
                    :value="option.userid"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">推广人</label>
                <el-select
                  class="jm-input280"
                  v-model="searchData.custom_promoter"
                  clearable
                  filterable
                  multiple
                  placeholder="请选择">
                  <el-option-group
                    v-for="(group, k) in createPerson"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="option in group"
                      :key="option.userid"
                      :label="option.username"
                      :value="option.userid"/>
                  </el-option-group>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">采集功能</label>
                <el-select v-model="searchData.create_point" filterable class="jm-input280" clearable multiple placeholder="请选择" color="red">
                  <el-option v-for="item in createPoint" :key="item.userid" :label="item.username" :value="item.userid" />
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">创建类型</label>
                <el-select
                  v-model="searchData.create_type"
                  class="jm-input280"
                  filterable
                  clearable>
                  <el-option
                    v-for="option in ds.create_type"
                    :key="option.id"
                    :label="option.value"
                    :value="option.id"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">活动编码</label>
                <el-input v-model="searchData.activity_code" class="jm-input280" />
              </div>
            </div>
            <div class="search-btn">
              <el-button
                class="jm-input135"
                type="primary"
                @click="init()">搜索</el-button>
            </div>
            <!--列表部分 start -->
            <p>
              数据说明
              <el-tooltip
                placement="right"
                effect="light">
                <div slot="content">
                  2026.08.20
                  <ul>
                    <li>分配数：按资源分配时间查询，创建时间可能小于分配时间，大于资源数，包含昆仑拉取数。</li>
                    <li>资源数：按资源创建时间查询，包含昆仑拉取数。</li>
                    <li>总签约数：按资源签约时间查询，查询出的签约数包含以前创建和分配的资源</li>
                    <li>总签约率：总签约数/分配数。</li>
                    <li>总签约金额：签约数所关联的学生的订单的实付总额的合计。</li>
                    <li>分配签约数：计算当月分配当月签，按资源签约时间和分配时间同时查询。</li>
                    <li>分配签约率：分配签约数/分配数。</li>
                  </ul>
                </div>
                <i class="el-icon-question blue"/>
              </el-tooltip>
            </p>
            <jm-tableList
              v-if="searchData"
              url="/training/bi.teacher/pagetable"
              :refresh.sync="refresh"
              :search-data="searchData"
              :no-pagination="true">
            </jm-tableList>
            <!--列表部分 end-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/tool/crumbs';
import jmTableList from '@/components/data/tableList';
import { jmChannel } from '@/components/tool';
import { formatSelectGroupData } from '@/utils/utils.js';
// import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      ds: {},
      refresh: false,
      searchData: {
        dept_id: '',
        teacher_id: [],
        custom_promoter: [],
        timeline: [],
        create_type: '',
        create_point: [],
        sale_proc: '',
        activity_code: '',
        channel: {
          custom_from: '',
          custom_from_sub: '',
          custom_from_thrid: '',
          custom_from_fourth: '',
          custom_from_fifth: '',
        }
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    jmChannel,
    jmTableList
  },
  mounted() {
    this.initTimeline();
    this.$http
      ._get({ url: '/training/bi.teacher/Index' })
      .then(({ data }) => {
        this.ds = Object.assign({}, this.ds, data);
        this.ds.create_point = Object.assign([], this.ds.create_person);
        if (this.ds.admin_dept_id) {
          this.searchData.dept_id = this.ds.admin_dept_id;
        }
      });
  },
  methods: {
    init() {
      this.refresh = true;
    },
    filterTeacher(option) {
      let deptId = this.searchData.dept_id;
      return (deptId && deptId === option.department) || !deptId;
    },
    initTimeline() {
      let dateToday = (new Date()).toLocaleDateString();
      let startMonth = dateToday.replace(RegExp('([0-9]+)$', ''), '');
      dateToday = dateToday.replace(RegExp('/', 'g'), '-');
      startMonth = startMonth.replace(RegExp('/', 'g'), '-');
      this.searchData.timeline = [`${startMonth}1`, dateToday];
    },
    changeGroupTeacher() {
      this.searchData.teacher_id = [];
    }
  },
  computed: {
    optionTeacherList() {
      if (this.ds.teacher) {
        return this.ds.teacher.filter((option) => {
          return this.filterTeacher(option);
        });
      }
      return [];
    },
    createPerson() {
      if (this.ds.create_person) {
        return formatSelectGroupData(this.ds.create_person.filter(item => item.userid > 0));
      }
      return [];
    },
    createPoint() {
      if (this.ds.create_point) {
        return this.ds.create_point.filter(item => item.userid < 0);
      }
      return [];
    },
  },
  watch: {}
};
</script>

<style scoped>
  .search-btn{
    clear: both;
    text-align: center;
    padding-bottom: 30px;
  }
</style>
